/* eslint-disable */

import JSLex from './JSLex'



function Scanner(_config, caseSensitive, errorCb) {
	var _lexer;
    var _pos = 0;
    var _tokens;
    var _success

	function buildLexer(config, caseSensitive, errorCb) {
	    var start = {};

	    start["#.*"] = null;
	    start["//.*"] = null;
	    for(var key in config) {
	    	if (config[key].regex !== undefined) {
		        start[config[key].regex] = {
		            code: config[key].code,
		            code_str: ""+key,
		            lexema: config[key].lexema,
		            caseSensitive: true

		        };
		    } else {
		    	let regex = '(' + config[key].keywords.join('|') + ')'
		    	start[regex] = {
		            code: config[key].code,
		            code_str: ""+key,
		            lexema: config[key].lexema,
		            caseSensitive: caseSensitive
		        };
		    }
	    }

	    start["[ \t\r\n]"] = null;
	    start["."] = {
	    	code: 0,
	    	code_str: 'error',
	    	lexema (text, line, column) {
		        _success = false
		        errorCb(text, line, column)
		    }
		}
	    return new JSLex( { "start": start } );
	}



	_lexer = buildLexer(_config, caseSensitive, errorCb);


	/**
	 * API
	 */

	var api = {};

	api.next = function() {
		if (_pos >= _tokens.length) {
			return {
				code: -1,
				lexema: 'fin de archivo',
				code_str: 'EOF'
			}
		}
		return _tokens[_pos];
	}
	api.nextIs = function(token) {

		if (_pos >= _tokens.length) {
			return false
		}

		if (typeof token != 'object') throw ("Se esperaba un objeto.")
		return _tokens[_pos].code == token.code;
	}

	api.consume = function() {

		if (_pos >= _tokens.length) {
			return {
				code: -1,
				lexema: 'fin de archivo',
				code_str: 'EOF'
			}
		}

		return _tokens[_pos++];
	}

	api.analyze = function(code) {
		_success = true
		_tokens = _lexer.collect(code);
		_pos = 0;
		return _success
	}

	api._dump = function() {
		let i
		for(i=0; i<_tokens.length; i++) {
			console.log(i+" - "+_tokens[i].code_str + ": " + _tokens[i].lexema)
		}
	}

	api.getLabel = function() {
		return _pos;
	}


	api.goToLabel = function(label) {
		_pos = label;
	}

    api.nextIsIn = function(list) {

		if (_pos >= _tokens.length) {
			return false
		}

        for(var i in list) {
            if (list[i].code == _tokens[_pos].code) {
                return true;
            }
        }
        return false;
    }


	return api;
}

export default Scanner


// WEBPACK FOOTER //
// ./src/Core/Parser/Scanner.js